import {
  setSuscripcionTarjetaP2PLoading,
  setSuscripcionTarjetaP2PHasErrror,
  setSuscripcionTarjetaP2PResponse
} from "../actions/aPagos";
import { handleActions } from 'redux-actions'


//------------------------- Inician Reducers -------------------------

export const rPlaceToPay = handleActions(
  {
    [setSuscripcionTarjetaP2PLoading]: (state) => ({ ...state,  suscripcionTarjetaP2PLoading: true}),
    [setSuscripcionTarjetaP2PHasErrror]: (state) => ({  ...state, suscripcionTarjetaP2PHasErrror: true}),
    [setSuscripcionTarjetaP2PResponse]: (state, action) => ({ ...state, suscripcionTarjetaP2PResponse: action.payload,
        suscripcionTarjetaP2PLoading: false, suscripcionTarjetaP2PHasErrror:false  }),
  },
  {
    suscripcionTarjetaP2PLoading: false,
    suscripcionTarjetaP2PHasErrror: false,
    suscripcionTarjetaP2PResponse: null
  }
);


//------------------------- Terminan Reducers -------------------------
